import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomepageService } from '../../../services/homepage.service';
import { SearchService } from '../../../services/search.service';
import { AuthService } from '../../../services/auth.service';
import { RouterExtService } from '../../../services/previous-route.service';
import { NotifierService } from 'angular-notifier';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-review-detail',
  templateUrl: './review-detail.component.html',
  styleUrls: ['./review-detail.component.css']
})
export class ReviewDetailComponent implements OnInit {
  private readonly notifier: NotifierService;
  constructor(private routerService: RouterExtService, private searchService: SearchService, private cookieService: CookieService, @Inject(DOCUMENT) private document: Document, private route: ActivatedRoute ,private homepageService: HomepageService, private authService: AuthService, private router: Router, notifierService: NotifierService) {
    this.notifier = notifierService;
   }
  reviewId: string;
  librarySetting: any = [];
  reviewDetail: any = [];
  responseAPIstatus: boolean = false;
  reviewCategories : any =[];
  selectedCategories:any = [];
  saveReviewStatus: boolean =false;
  loginUser : any = [];
  isEditAndPublishReview: boolean =false;
  isAdmin: boolean =false;
  patronNumber: string = null; //Changes type number --> string
  previousUrl:string = '';
  previousUrlTxt:string = '';
  haveApiError: boolean = false;
  ispublish : boolean = false;
  reviewerNameReadOnly : boolean = true;
  shoModalEdit : boolean = false;
  ngOnInit() {
  	this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('list');
    this.reviewId = this.route.snapshot.paramMap.get("id");
    this.librarySetting  = this.homepageService.getUpdatedConfig();  
    this.routerService.setTextUrl('Review Detail');  
     /******************* Get Review categories **************/

    this.homepageService.getReviewCategories().subscribe((data)=>{
      this.reviewCategories = data;                                                                                                                                                           
    });

    /******************* Get Review categories **************/
    //if(this.cookieService.check( 'info')){
    // if (localStorage.getItem('info') != null){
    //   this.isLogin = true;
    // } else {
    //   this.isLogin = false;       
    // }
    if(this.cookieService.check( 'patronPermissions' ) ){
      var permissions = JSON.parse(this.cookieService.get( 'patronPermissions' ));        
      var details = JSON.parse(this.cookieService.get( 'userDetail' ));        
      this.isEditAndPublishReview = permissions.opacEditAndPublishReview;        
      this.isAdmin = permissions.opacAdmin;        
      this.patronNumber = details.patronNumber;        
    }
    this.getReviewDetail(); 
    this.previousUrl = this.routerService.getPreviousUrl();  
    this.previousUrlTxt = this.routerService.getTextUrl(); 
  }

  getReviewDetail(){
    this.haveApiError = false;
  	this.homepageService.getReviewDetail(this.reviewId).subscribe((data:any) =>{
  		this.reviewDetail = data.data;
      this.ispublish = this.reviewDetail.published;
       if(this.reviewDetail.reviewer == null){
        this.reviewerNameReadOnly = false;
      } else {
        this.reviewerNameReadOnly = true;
      }
      this.homepageService.updateBannerText(this.reviewDetail.title);
      this.reviewDetail.reviewCategories.forEach((cat) => {
        this.selectedCategories.push(cat.id);
      });
  		this.responseAPIstatus = true;
  	},(err) => {
      this.responseAPIstatus = true;
      this.haveApiError = true;
      if(err.error.Status !== 500){
        var self = this;
        setTimeout(function(){
          if(typeof(self.previousUrl) != 'undefined'){
            self.router.navigate([self.previousUrl]);
          } else {
            self.router.navigate(['/']);
          }
        },2000);        
      }
    });
  }

  //Showing icon for image error.
  imageError(event, images){
    if(typeof($('body').find('img[custom="'+event+'"]').attr('index')) != 'undefined' &&  parseInt($('body').find('img[custom="'+event+'"]').attr('index')) > 0 ){
      var index:number = parseInt($('body').find('img[custom="'+event+'"]').attr('index'));
      if(typeof($('body').find('img[custom="'+event+'"]').attr('loaded')) != 'undefined')
      index--;
      this.imageLoad(event, images,index, true);
    } else {
      $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('img[custom="'+event+'"]').remove();          
    }
  }

  //loading best image
  imageLoad(event, images,index, fromError = false) {
    //console.log(event, 'ImageID');
    if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes' && !fromError) {
      return false;
    }
    if($('body').find('#'+event).length <= 0) {
       $('body').append('<img id="'+event+'" src="" style="display:none;">');
    }
    var $this = this;
    var imagesAll = this.searchService.sortedImage(images);
    $('#'+event).attr('src',imagesAll[index]);
    setTimeout(function(){
      var tempWidth = $('#'+event).width();
      //console.log(tempWidth, event, index);
      var temp = document.getElementById(event);
      if(tempWidth <= 1 && index > 0){
        $this.imageLoad(event,images,index-1, true);
        return false;
      }else if(tempWidth <= 1 && index == 0){
        $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('img[custom="'+event+'"]').remove();
      }
    },500);
    if(typeof(imagesAll[index]) != 'undefined') {
      $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[index]);
      $('body').find('img[custom="'+event+'"]').attr('loaded','yes');        
      $('body').find('img[custom="'+event+'"]').attr('index',index);        
    }
  }

	/*imageLoad(event, images) {
	    var sizes = ['xl','l','m','s','xs','xxs'];     
     	var imagesAll = [];
     	sizes.forEach((evt) => {
      		images.forEach((img) => {
		        if(img.size == evt){
		          imagesAll.push(img.url);
		        }
	      	});      
    	});    
    	setTimeout(function() {
    		if(typeof(imagesAll[0]) != 'undefined') {
	      		$(event.target).attr('src',imagesAll[0]);
    		} 
  		},10);    
  	}
*/
  onRatingChange(event){    
    $('#reviewStar').val(event.rating);
  }


  editReview(){
    var error= 0;
    var Id = $('#reviewid').val();
    var ratingStar = $('#reviewStar').val();
    var reviewText = $('#reviewText').val();
    var reviewPublished:boolean = $('#ReviewPublished').is(':checked');
    if($.trim(reviewText.toString()) == ''){
      $('#reviewText').addClass('error');
      error++;
    }
    var reviewer = $('#reviewerName').val();
    if($.trim(reviewer.toString()) == ''){
      $('#reviewerName').addClass('error');
      error++;
    }
    if(error != 0){
      return false;
    }
    this.saveReviewStatus = true;
    var categories = [];
    $('.reviewCategory').find('input[type="checkbox"]:checked').each(function(){
      categories.push($(this).val());
    });
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
    }
    this.homepageService.editReview(Id, ratingStar, reviewText,reviewPublished, reviewer,categories,token).subscribe((data) => {
      this.notifier.notify( 'success', 'Review has been updated successfully');
      $('#closereviewAdd').trigger('click');              
      this.getReviewDetail();   
      this.saveReviewStatus = false;
    },(err) => {
      this.notifier.notify( 'error', 'Something went wrong.Try again.');
    });
  }

  deleteReview(id){
    if(confirm('Are you sure?')){
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
      }
      this.homepageService.deleteReview(id, token).subscribe((data) => {
        this.notifier.notify( 'success', 'Review has been deleted successfully');
        this.router.navigate(['/searchreview']);                  
       },(err) => {
        this.notifier.notify( 'error', 'Something went wrong.Try again.');
      });
    }
  }

  publishReview(reviewId,event){
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
    }
    var selector = $(event.target);
    if(event.target.nodeName == 'I'){
      var selector = $(event.target).parent();
    } 
    selector.removeClass('show').addClass('hide');    
    this.homepageService.publishReview(reviewId, token).subscribe((data) => {
      if(selector.hasClass('Publish')){
         this.notifier.notify( 'success', "Review has been published");
        this.ispublish = true;
        selector.parent().find('.unPublish').removeClass('hide').addClass('show');        
      } else {
        this.notifier.notify( 'success', "Review has been unpublished");
        this.ispublish = false;
        selector.parent().find('.Publish').removeClass('hide').addClass('show');
      }
    },(err) => {
      this.notifier.notify( 'error', 'Something went wrong.Try again.');
      selector.removeClass('hide').addClass('show');
    });
  }

  showEditModal(){
    this.shoModalEdit = true;
  }
  hideEditModal(){
    this.shoModalEdit = false;
  }
}
